
export enum EntityTypes {
  Organization = 1,
  Location = 2,
  Tank = 3,
  Group = 99
}
